module.exports = __webpack_public_path__ + "fonts/montserrat-medium-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Montserrat/montserrat-medium-webfont.ttf
// module id = 3439
// module chunks = 0